import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { ShowErrorsDialogComponent } from '@core_n/show-errors/show-errors.component';

@Component({
  selector: 'app-msg-box',
  templateUrl: './msg-box.component.html',
  styleUrls: ['./msg-box.component.scss']
})
export class MsgBoxComponent implements OnInit {

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any,
    private snackBarRef: MatSnackBarRef<MsgBoxComponent>,
    protected dialog: MatDialog,
  ) {
  }

  ngOnInit() {
  }

  getIcon() {
    switch (this.data.msgType) {
      case 'Success':
        return 'check_circle';
      case 'Error':
        return 'error';
      case 'Warn':
        return 'warning';
      case 'Info':
        return 'notifications';
    }
  }

  onBtnClick() {
    this.snackBarRef.dismiss();
  }
}
